var app = angular.module('leonardo');

var WidgetEmails = function(FilterService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      filter:'@'
    },
    templateUrl: 'views/templates/widget/widget-emails.html',
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };
      scope.init = false;

      scope.ngModelCtrl.$render = function () {
        scope.emails = scope.ngModelCtrl.$viewValue;
        if (isNull(scope.emails) && scope.filter) {
          scope.emails = FilterService.getFilter(scope.filter);
        }
        if (!isEmpty(scope.emails)) {
          scope.emails = (angular.isArray(scope.emails) ? scope.emails : scope.emails.split(','));
        }
        else {
          scope.emails = [''];
        }
      };

      scope.updateModel = function() {
        var emails = [];
        angular.forEach(scope.emails, function (email) {
          if (!isEmpty(email)) {
            emails.push(email);
          }
        });
        scope.ngModelCtrl.$setViewValue(emails);
        if (scope.filter) {
          FilterService.setFilter(scope.filter, emails);
        }
      };

      scope.$watch('emails', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          scope.updateModel();
          scope.init = true;
        }
      });

      scope.removeEmail = function(index) {
        var emails = angular.copy(scope.emails);
        if (emails.length === 1) {
          emails[0] = '';
        }
        else {
          angular.forEach(scope.emails, function(value, key){
            if (key > index) {
              emails[key-1] = emails[key];
            }
          });
          emails.splice(emails.length-1, 1);
        }
        scope.emails = emails;
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        var empty = true;
        angular.forEach(modelValue, function (email) {
          if (!isEmpty(email)){
            empty = false;
          }
        });
        return !empty;
      };

    }
  };
};

app.directive('widgetEmails', ['FilterService', WidgetEmails]);
